import { render, staticRenderFns } from "./NewsCategoryAdd.vue?vue&type=template&id=1d6cf59a&scoped=true&"
import script from "./NewsCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cf59a",
  null
  
)

export default component.exports